import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// Auto-refresh the access token on 401 using the long-lived refresh_token cookie,
// then retry the original request once. Prevents "Not authenticated" after the
// 60-minute access token expires mid-session (e.g. when clicking Deploy).
let refreshPromise = null;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    // Only skip refresh-retry for auth mutation endpoints (avoids refresh loops).
    // Protected reads like /api/auth/me SHOULD auto-recover on 401.
    const isAuthMutation = /\/api\/auth\/(refresh|login|register|logout)$/.test(url);
    if (status === 401 && original && !original._retry && !isAuthMutation) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/api/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (refreshError) {
        refreshPromise = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
